<template>
  <app-view>
    <div class="content">
      <movie-cover
        v-for="(item,index) in list"
        :key="index"
        :value="item"
        event="selected"
        more="simple"
        @selected="onSelected"
        @longTap="onLongTap"
      ></movie-cover>
    </div>
    <div class="none" v-if="list.length===0">暂时没有播放记录</div>
    <div class="tip">提示：长按可进行删除操作</div>
    <app-confirm ref="confirm"></app-confirm>
  </app-view>
</template>
<script>
import AppConfirm from '../components/AppConfirm.vue'

export default {
  components: { AppConfirm },
  data() {
    return {
      list: []
    }
  },
  async mounted() {
    let { data } = await this.$service.user.getPlaybacks()
    data.forEach(d => {
      d.pic = d.thumb
      d.movid = d.tid
    })
    this.list = data
  },
  methods: {
    onSelected(item) {
      this.$router.push({
        name: 'movie',
        params: {
          movid: item.movid
        },
        query: {
          urlid: item.urlid
        }
      })
    },
    async onLongTap(item) {
      if (await this.$refs.confirm.show('您确定要删除该播放记录?')) {
        let index = this.list.indexOf(item)
        if (index >= 0) {
          await this.$service.user.removePlayback(item.id)
          this.list.splice(index, 1)
        }
      }
    }
  }
}
</script>
<style scoped lang='scss'>
.view {
  padding-bottom: 50px;
  .none {
    padding-top: 100px;
    text-align: center;
    color: $secondly-text-color;
  }
  .tip {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    font-size: 12px;
    padding: 2px 0;
    background-color: $color-white;
    text-align: center;
    color: $secondly-text-color;
  }
  .content {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    padding: rem(6);
    > a {
      margin: rem(6);
    }
  }
  @media screen and (min-width: 768px) {
    .content {
      padding: rem(3);
      > a {
        margin: rem(3.5);
      }
    }
  }

  @media screen and (min-width: 1024px) {
    .content {
      padding: rem(3);
      > a {
        margin: rem(2.5);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?24aa482b